import React from 'react'
import { Button, Typography } from '@material-ui/core'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import ReactLoading from 'react-loading'
import { useIntl } from 'src/common/razzle-platform-translate'


const useCancelButtonStyles = makeStyles((theme) => ({
    cancelButton: {
        marginRight: 8,
    },
}))

export const DefaultCancelButton = (props) => {
    const { onCancel, disabled } = props
    const classes = useCancelButtonStyles()
    const { formatMessage } = useIntl()

    return (
        <Button
            onClick={() => onCancel()}
            className={classes.cancelButton}
            size="small"
            disabled={disabled}
            >
            <Typography>{ formatMessage({ id: 'Annuler', defaultMessage: 'Annuler' }) }</Typography>
        </Button>
    )
}



const useInitializeButtonStyles = makeStyles((theme) => ({
    initializeButton: {
        marginRight: 8,
        marginLeft: 0
    },
}))

export const DefaultInitializeButton = (props) => {
    const { onInitialize, disabled } = props
    const classes = useInitializeButtonStyles()
    const { formatMessage } = useIntl()

    return (
        <Button
            onClick={() => onInitialize()}
            variant="contained"
            disableElevation
            className={classes.initializeButton}
            size="small"
            disabled={disabled}
            >
            <Typography>{ formatMessage({ id: 'Initialiser', defaultMessage: 'Initialiser' }) }</Typography>
        </Button>
    )
}




const useConfirmButtonStyles = makeStyles((theme) => ({
    loadingButton: {
        marginRight: 7
    }
}))

export const DefaultConfirmButton = (props) => {
    const { onConfirm, disabled, inProgress } = props
    const classes = useConfirmButtonStyles()
    const theme = useTheme()
    const { formatMessage } = useIntl()

    return (
        <Button
            onClick={() => onConfirm()}
            variant="contained"
            color="primary"
            size="small"
            disableElevation
            disableFocusRipple
            disableRipple
            disabled={disabled}
        >
            { inProgress && <ReactLoading type={'spokes'} color={theme.palette.primary.main} height={20} width={19} className={classes.loadingButton} /> }
            <Typography >{ formatMessage({ id: 'Réserver', defaultMessage: 'Réserver' }) } </Typography>
        </Button>
    )
}
